"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectorGroups = exports.getSelectorGroup = exports.SELECTOR_HOVER = exports.BLOCK_NAME_INTERACTED = exports.BLOCK_NAME_HOVER = exports.BLOCK_NAME_FOCUS = exports.BLOCK_NAME_DISABLED = void 0;
const BLOCK_NAME_DISABLED = exports.BLOCK_NAME_DISABLED = 'disabled';
// any of hover, focus, active. what about visited?
const BLOCK_NAME_INTERACTED = exports.BLOCK_NAME_INTERACTED = 'interacted';
const BLOCK_NAME_HOVER = exports.BLOCK_NAME_HOVER = 'hover';
const BLOCK_NAME_FOCUS = exports.BLOCK_NAME_FOCUS = 'focus';
const SELECTOR_HOVER = exports.SELECTOR_HOVER = ':hover';
const DISABLED_SELECTORS = ['[disabled]', '[disabled]:hover', '[disabled]:focus', '[disabled]:active', '[disabled]:visited', '.disabled', '.disabled:hover', '.disabled:focus', '.disabled:active', '.disabled:visited'];
const INTERACTED_SELECTORS = [SELECTOR_HOVER, ':focus', ':active'];
const HOVER_SELECTORS = [SELECTOR_HOVER, ':active'];
const selectorGroups = exports.selectorGroups = {
  [BLOCK_NAME_DISABLED]: DISABLED_SELECTORS,
  [BLOCK_NAME_HOVER]: HOVER_SELECTORS,
  [BLOCK_NAME_INTERACTED]: INTERACTED_SELECTORS
};

// getSelectorGroup('disabled') => '[disabled], [disabled]:hover, [disabled]:focus, [disabled]:active, [disabled]:visited, .disabled, .disabled:hover, .disabled:focus, .disabled:active, .disabled:visited'
const getSelectorGroup = ({
  selectors,
  blockName,
  opts
}) => {
  if (!selectors && !blockName) {
    throw new Error('selectors or blockName is required');
  }
  const {
    applyToElementDirectly = false,
    returnListInsteadOfString = false
  } = opts || {};
  const internalSelectors = blockName && selectorGroups[blockName] ? selectorGroups[blockName] : selectors;
  if (applyToElementDirectly) {
    const mappedSelectors = internalSelectors.map(selector => `${!selector?.startsWith('&') ? '&' : ''}${selector}`);
    return returnListInsteadOfString ? mappedSelectors : mappedSelectors.join(', ');
  }
  return returnListInsteadOfString ? internalSelectors : internalSelectors.join(', ');
};
exports.getSelectorGroup = getSelectorGroup;